import { render, staticRenderFns } from "./FarmsTable.vue?vue&type=template&id=f3c14860&scoped=true&"
import script from "./FarmsTable.vue?vue&type=script&lang=js&"
export * from "./FarmsTable.vue?vue&type=script&lang=js&"
import style0 from "./FarmsTable.vue?vue&type=style&index=0&id=f3c14860&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c14860",
  null
  
)

export default component.exports